
const digest = 'f0203b47dfecc7e8c3dd3eb5aa36fa4fc517ee9b5adb30c2b03cd00e1f4cbf36';
const classes = {"wrapper":"_wrapper_1mty0_1","table":"_table_1mty0_7"};
const css = `._wrapper_1mty0_1 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

._table_1mty0_7 {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  border: 1px solid #d8dee7;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: table;
  table-layout: auto;
}
._table_1mty0_7 thead {
  display: table-header-group;
}
._table_1mty0_7 thead tr {
  display: table-row;
}
._table_1mty0_7 thead tr th {
  display: table-cell;
  font-weight: 500;
  font-size: 14px;
  background-color: #f5f7fa;
  color: #000000;
  padding: 16px;
  text-align: left;
  font-family: Rubik, sans-serif;
  border: 1px solid #d8dee7;
  border-bottom: 2px solid #d8dee7;
}
._table_1mty0_7 tbody {
  display: table-row-group;
}
._table_1mty0_7 tbody tr {
  display: table-row;
  border-bottom: 1px solid #d8dee7;
}
._table_1mty0_7 tbody tr:last-child {
  border-bottom: none;
}
._table_1mty0_7 tbody td {
  display: table-cell;
  padding: 16px;
  text-align: left;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  background-color: #ffffff;
  vertical-align: top;
  border: 1px solid #e9edf0;
  width: 250px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  